
//LOGIN
export const GET_LOGIN = "/api/openWeb/user/v1/sessionToken"
export const POST_FORGOT_PASSWORD = "/api/openWeb/user/v1/forgotPassword"
export const POST_RESET_PASSWORD = "/api/authWeb/user/v1/resetPassword"

// USER PUBLIC KEY
export const GET_USER_PUBLIC_KEY = "/api/authWeb/user/v1/userPublicKey"

// USERS - CMS App Users API
export const GET_USERS = "/api/authWeb/amos/cms/v1/cmsAppUsers"
export const MANAGE_USER = "/api/authWeb/amos/cms/v1/manageCmsAppUser"
export const GET_AUTHORIZATION_GROUPS = "/api/authWeb/amos/cms/v1/authorizationGroups"

// TOKEN REFRESH
export const POST_REFRESH_TOKEN = "/api/authWeb/user/v1/refreshToken"

// LOGOUT
export const POST_LOGOUT = "/api/authWeb/user/v1/invalidateToken"

// App Init Lookup // App Info
export const GET_APP_INFO = "/api/openWeb/system/v1/appInitLookups"

// User App Menu
export const GET_USER_APP_MENU = "/api/authWeb/user/v1/userAppMenus"

// is User authorized
export const GET_USER_AUTHORIZED = "/api/authWeb/system/v1/isUserAuthorized"

// ERROR REPORTING
export const POST_REPORT_APP_CRASH = "/api/openWeb/system/v1/reportAppCrash"

// DASHBOARD
export const GET_DASHBOARD = "/api/authWeb/amos/cms/v1/dashboard"

// BRANDS
export const GET_BRANDS = "/api/openWeb/ecommerce/v1/brands"
export const MANAGE_BRAND = "/api/authWeb/ecommerce/v1/manageBrand"

// Merchant Group
export const GET_MERCHANT_GROUP = "/api/authWeb/ecommerce/v1/merchantGroups"
export const MANAGE_MERCHANT_GROUP =
  "/api/authWeb/ecommerce/v1/manageMerchantGroup"

// Merchant Group Communications
export const GET_MERCHANT_GROUP_COMMUNICATIONS =
  "/api/authWeb/ecommerce/v1/merchantGroupCommunications"

export const MANAGE_MERCHANT_GROUP_COMMUNICATION =
  "/api/authWeb/ecommerce/v1/manageMerchantGroupCommunication"

// Communication Channels Lookup
export const GET_COMM_CHANNELS = "/api/openWeb/lookup/v1/commChannels"

// Currencies Lookup
export const GET_CURRENCIES = "/api/openWeb/lookup/v1/currencies"

// Merchant Group Contacts
export const GET_MERCHANT_GROUP_CONTACTS =
  "/api/authWeb/ecommerce/v1/merchantGroupContacts"
export const MANAGE_MERCHANT_GROUP_CONTACT =
  "/api/authWeb/ecommerce/v1/manageMerchantGroupContact"

// Merchant Group Contact Communications
export const GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS =
  "/api/authWeb/ecommerce/v1/merchantGroupContactCommunications"
export const MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION =
  "/api/authWeb/ecommerce/v1/manageMerchantGroupContactCommunication"

// Merchant Group Banking
export const GET_MERCHANT_GROUP_BANKING =
  "/api/authWeb/payment/v1/merchantGroupBanking"
export const MANAGE_MERCHANT_GROUP_BANKING =
  "/api/authWeb/payment/v1/createMerchantGroupBanking"
export const TOGGLE_MERCHANT_GROUP_BANKING_STATUS =
  "/api/authWeb/payment/v1/toggleMerchantGroupBankingState"
export const TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT =
  "/api/authWeb/payment/v1/toggleMerchantGroupBankingDefaultSettlementFlag"
export const CHECK_MERCHANT_GROUP_BANKING_STATUS =
  "/api/authWeb/payment/v1/merchantGroupBankingStatus"

  
// Merchant Group Admin User
export const GET_MERCHANT_GROUP_ADMIN = "/api/authWeb/ecommerce/v1/merchantGroupAdmin"
export const CREATE_MERCHANT_GROUP_ADMIN = "/api/authWeb/ecommerce/v1/createMerchantGroupAdmin"

// Merchants
export const GET_MERCHANTS = "/api/authWeb/ecommerce/v1/merchants"
export const MANAGE_MERCHANT = "/api/authWeb/ecommerce/v1/manageMerchant"

// Merchant Communications
export const GET_MERCHANT_COMMUNICATIONS = "/api/authWeb/ecommerce/v1/merchantCommunications"
export const MANAGE_MERCHANT_COMMUNICATION = "/api/authWeb/ecommerce/v1/manageMerchantCommunication"

// Merchant Contacts
export const GET_MERCHANT_CONTACTS = "/api/authWeb/ecommerce/v1/merchantContacts"
export const MANAGE_MERCHANT_CONTACT = "/api/authWeb/ecommerce/v1/manageMerchantContact"

// Merchant Contact Communications
export const GET_MERCHANT_CONTACT_COMMUNICATIONS = "/api/authWeb/ecommerce/v1/merchantContactCommunications"
export const MANAGE_MERCHANT_CONTACT_COMMUNICATION = "/api/authWeb/ecommerce/v1/manageMerchantContactCommunication"

// Merchant Banking
export const GET_MERCHANT_BANKING = "/api/authWeb/payment/v1/merchantBanking"
export const MANAGE_MERCHANT_BANKING = "/api/authWeb/payment/v1/createMerchantBanking"
export const TOGGLE_MERCHANT_BANKING_STATUS = "/api/authWeb/payment/v1/toggleMerchantBankingState"
export const TOGGLE_MERCHANT_BANKING_DEFAULT = "/api/authWeb/payment/v1/toggleMerchantBankingDefaultSettlementFlag"
export const CHECK_MERCHANT_BANKING_STATUS = "/api/authWeb/payment/v1/merchantBankingStatus"
// Merchant Images
export const GET_MERCHANT_IMAGES = "/api/authWeb/ecommerce/v1/merchantImages"
export const MANAGE_MERCHANT_IMAGE = "/api/authWeb/ecommerce/v1/manageMerchantImage"
export const REORDER_MERCHANT_IMAGES = "/api/authWeb/ecommerce/v1/reorderMerchantImages"


// Merchant Timings
export const GET_MERCHANT_TIMINGS = "/api/authWeb/ecommerce/v1/merchantTimings"
export const MANAGE_MERCHANT_TIMING = "/api/authWeb/ecommerce/v1/manageMerchantTimings"

// Merchant Tags APIs
export const GET_MERCHANT_TAGS = "/api/authWeb/ecommerce/v1/merchantTags"
export const MANAGE_MERCHANT_TAG = "/api/authWeb/ecommerce/v1/manageMerchantTags"
export const GET_TAG_DEFINITIONS = "/api/openWeb/ecommerce/v1/merchantTagDefs"
// Merchant Attributes
export const GET_MERCHANT_ATTRIBUTES = "/api/authWeb/ecommerce/v1/merchantAttributes"
export const MANAGE_MERCHANT_ATTRIBUTE = "/api/authWeb/ecommerce/v1/manageMerchantAttributes"

// Merchant Variables
export const CREATE_MERCHANT_VARIABLES = "/api/authWeb/amos/cms/v1/createMerchantVariables"
export const UPDATE_MERCHANT_VARIABLES = "/api/authWeb/amos/cms/v1/updateMerchantVariables"
export const GET_MERCHANT_VARIABLES = "/api/authWeb/amos/cms/v1/merchantVariables"
export const GET_RECONCILIATION_FREQUENCIES = "/api/openWeb/lookup/v1/reconciliationFrequencies"

// Merchant PINs
export const GET_MERCHANT_PINS = "/api/authWeb/ecommerce/v1/merchantPINs"
export const SHOW_MERCHANT_PINS = "/api/authWeb/ecommerce/v1/showMerchantPINs"
export const UPDATE_MERCHANT_PINS = "/api/authWeb/ecommerce/v1/updateMerchantPINs"


// Cities
export const GET_CITIES = "/api/openWeb/lookup/v1/cities"

// Municipalities
export const GET_MUNICIPALITIES = "/api/openWeb/lookup/v1/municipalities"

// Supported banks (Bank Identifier lookup for banking forms — CMS.Banking requirement)
export const GET_SUPPORTED_BANKS = "/api/authWeb/payment/v1/supportedBanks"

// uploadBase64File
export const UPLOAD_BASE64_FILE = "/api/authWeb/file/v1/uploadBase64File"

// uploadMultiPartFile
export const UPLOAD_MULTIPART_FILE = "/api/authWeb/file/v1/uploadMultiPartFile"

//PROFILE
export const GET_USER_PROFILE_INFO = "/api/authWeb/user/v1/userProfile"
export const UPDATE_USER_PROFILE = "/api/authWeb/user/v1/updateUserProfile"

// EMAIL VERIFICATION
export const SEND_VERIFICATION_CODE = "/api/openWeb/social/v1/sendVerificationCode"
export const VALIDATE_VERIFICATION_CODE = "/api/openWeb/social/v1/validateVerificationCode"


// OFFERS
export const GET_CURATOR_OFFERS = "/api/authWeb/amos/cms/v1/curatorOffers"
export const GET_OPERATION_OFFERS = "/api/authWeb/amos/cms/v1/operationsOffers"
export const GET_APPROVER_OFFERS = "/api/authWeb/amos/cms/v1/approverOffers"
export const GET_PUBLISHED_OFFERS = "/api/authWeb/amos/cms/v1/publishedOffers"
export const MANAGE_CURATOR_OFFER = "/api/authWeb/amos/cms/v1/manageCuratorOffer"
export const MANAGE_OPERATIONS_OFFER = "/api/authWeb/amos/cms/v1/manageOperationsOffer"
export const MANAGE_PUBLISHED_OFFER = "/api/authWeb/amos/cms/v1/managePublishedOffer"

// OFFER TABS
export const GET_OFFER_TAGS = "/api/authWeb/amos/cms/v1/offerTags"
export const MANAGE_OFFER_TAGS = "/api/authWeb/amos/cms/v1/manageOfferTags"
export const GET_OFFER_TAG_DEFINITIONS = "/api/openWeb/amos/cms/v1/offerTagDefs" //dont add cms to this endpoint, will do this later on when update the backend
export const GET_OFFER_INCLUSIONS = "/api/authWeb/amos/cms/v1/offerInclusions"
export const MANAGE_OFFER_INCLUSIONS = "/api/authWeb/amos/cms/v1/manageOfferInclusions"
export const GET_OFFER_EXCLUSIONS = "/api/authWeb/amos/cms/v1/offerExclusions"
export const MANAGE_OFFER_EXCLUSIONS = "/api/authWeb/amos/cms/v1/manageOfferExclusions"
export const GET_OFFER_TERMS_CONDITIONS = "/api/authWeb/amos/cms/v1/offerTermsConditions"
export const MANAGE_OFFER_TERMS_CONDITIONS = "/api/authWeb/amos/cms/v1/manageOfferTermsConditions"

// OFFER STATE HISTORY
export const GET_OFFER_STATE_HISTORY = "/api/authWeb/amos/cms/v1/offerStateHistory"

// OFFER ACTIONS
export const POST_OFFER = "/api/authWeb/amos/cms/v1/postOffer"
export const REJECT_OFFER = "/api/authWeb/amos/cms/v1/rejectOffer"
export const PROCESS_OFFER = "/api/authWeb/amos/cms/v1/processOffer"
export const PUBLISH_OFFER = "/api/authWeb/amos/cms/v1/publishOffer"
export const DENY_OFFER = "/api/authWeb/amos/cms/v1/denyOffer"

// NOTIFICATIONS
export const GET_NOTIFICATIONS = "/api/authWeb/social/v1/notifications"
export const MANAGE_NOTIFICATION = "/api/authWeb/social/v1/manageNotification"
export const TOGGLE_NOTIFICATION_READ_UNREAD = "/api/authWeb/social/v1/toggleNotificationReadUnread"